import React from 'react'
import { useRegisterInfluencer } from '../../hooks/useRegisterInfluencer'
import { getRegisterInfluencerFormValues } from '../../utils/getRegisterInfluencerFormValues'
import {
  editInfluencerFormValidationSchema,
  registerInfluencerFormValidationSchema
} from '../../validation/registerInfluencerForm'
import { Form } from '../Form'

export const InfluencerForm = ({
  children,
  isEditing = false,
  defaultValues = {}
}) => {
  const {
    mutate: register,
    isLoading,
    isSuccess
  } = useRegisterInfluencer(!isEditing ? 'create' : 'update')
  const handleSubmit = (args, { setError }) => {
    void register(getRegisterInfluencerFormValues(args), {
      onError: error => {
        let key = ''
        if (
          error &&
          error.message &&
          error.message.keys &&
          error.message.keys.keyPattern
        ) {
          key = Object.keys(error.message.keys.keyPattern)[0]
        }

        if (key === 'username') {
          const fieldName = 'email'
          setError(
            fieldName,
            {
              type: 'focus',
              message: 'Email already exists'
            },
            { shouldFocus: true }
          )
        }
      }
    })
  }

  return (
    <Form
      onSubmit={handleSubmit}
      defaultValues={
        isEditing
          ? defaultValues
          : {
              sameAsShipping: true,
              verticals: {}
            }
      }
      validationSchema={
        isEditing
          ? editInfluencerFormValidationSchema
          : registerInfluencerFormValidationSchema
      }
    >
      {React.cloneElement(children, { isLoading, isSuccess, defaultValues })}
    </Form>
  )
}
